// @ts-nocheck


import React, { useState, useCallback } from 'react';

import { goBack } from '../../lib/helpers';
import { inspectionGibddCostApi } from '../../lib/api';


import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';
import { getBreadCrumbsByUrlForEdit } from '../../lib/autoBreadcrumbs';





const entryPointPath = '/admin/inspection-gibdd-cost/';

export default (props) => {
  const [data, setData] = useState({ id: props.id });

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, data.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await inspectionGibddCostApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload) => {
    let id = payload.id;
    if (id) {
      await inspectionGibddCostApi.update(payload);
    } else {
      let data = await inspectionGibddCostApi.add(payload);
      id = data.id;
    }
    await goBack(`${entryPointPath}${id}`);
  };

  const onCancel = async (payload) => {
    if (data.id) {
      await goBack(`${entryPointPath}${data.id}`);
    } else await goBack(`${entryPointPath}`);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Стоимость ТО ГИБДД'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}>

      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>);

};
